<template>
  <div>
    <v-dialog
      fullscreen
      :lazy="$route.name != 'allocation'"
      @keydown.esc="emitInput(false)"
      :value="value"
      @input="emitInput($event.target.value)"
    >
      <docket-add
        @close="emitInput(false)"
        @addedDocket="addedDocket()"
        @addedAdjustment="addedAdjustment"
      ></docket-add>
    </v-dialog>

    <v-dialog
      v-model="queryDialog"
      max-width="400px"
      @keydown.enter="addAnotherDocket()"
      @keydown.esc="queryDialog = false"
    >
      <v-card>
        <v-card-title class="headline">Add another?</v-card-title>
        <v-card-text>Would you like to add another docket now?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click="addAnotherDocket()"
            :color="$store.state.global.pages.docket.color"
          >Yes</v-btn>
          <v-btn flat @click="quitDocketEntry()" :color="primaryGrey">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CREATE DOCKET ADJUSTMENT PDF COMPONENT-->
    <v-dialog v-model="pdfDialog" max-width="400px" @keydown.esc="pdfDialog = false" lazy>
      <make-pdf :docketAdjustment="docketAdjustment" @closed="addedDocket()"></make-pdf>
    </v-dialog>
  </div>
</template>

<script>
import DocketAdd from "@/views/backEnd/docketAdd";
import Store from "@/store/computed/storeHelpers";
import MakePdf from "@/components/trips/actions/makePdf";
export default {
  data() {
    return {
      queryDialog: false,
      docketAdjustment: null
    };
  },
  methods: {
    emitInput(val) {
      this.$store.commit("dockets/setState", {
        prop: "creditData",
        value: null
      });
      this.$emit("input", val);
    },
    addedDocket() {
      this.emitInput(false);
      this.queryDialog = true;
    },
    addedAdjustment(pdfDocket) {
      this.emitInput(false);
      this.docketAdjustment = pdfDocket;
      this.pdfDialog = true;
    },
    addAnotherDocket() {
      this.queryDialog = false;
      this.emitInput(true);
    },
    quitDocketEntry() {
      this.$store.dispatch("dockets/resetFormFull");
      this.queryDialog = false;
    }
  },
  computed: {
    pdfDialog: Store.getSet({ store: "shared", prop: "pdfDialog" })
  },
  props: {
    value: Boolean
  },
  components: {
    DocketAdd,
    MakePdf
  }
};
</script>

<style>
</style>
